module.exports = __webpack_public_path__ + "media/images/client-6-335b8760731877d4e336d1068faa2577.png";